import script from "./AppAndroidUpdateModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./AppAndroidUpdateModal.vue?vue&type=script&setup=true&lang=ts"

import "./AppAndroidUpdateModal.vue?vue&type=style&index=0&id=5217f5f0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5217f5f0"]])

export default __exports__